module.exports = __webpack_public_path__ + "static/media/ed.4a810416.png";